
/*
**  TagCommander-koppling vid laddning.
**  Denna vägen kopplas de flesta (icke)-react komponenter,
*/

/* TODO REIMPLEMENT INITIATION FOR TAGCOMMANDEREVENTS IN PRODUCTION WHEN READY */
import { tcEventProductListView, tcEventProductClick, tcEventClickAddToCart, tcEventDocumentationDownload, tcEventFAQ, tcEventClickProductTab, tcEventClickNavigation, tcEventClickSort, 
    tcEventClickBuyOnlineRetailerLogo, tcEventClickOnlineButton, tcEventClickSeeRecipe, tcEventClickExitLink } from './Actions/TagCommander.action'

if (document.querySelectorAll('[data-tc]').length > 0) {
    Array.from(document.querySelectorAll('[data-tc]')).forEach((tagCommanderElement) => {
        const { tcProductlistview, tcProductclick, tcClickdownload, tcClickfaq, tcClickproducttab, tcClicknavigation, tcClicksort, tcClickbuyonlineretailerlogo, tcClickbuyonlinebutton, tcClickseerecipe } = tagCommanderElement.dataset
        
        if (tcProductlistview) {
            tcEventProductListView(tcProductlistview, tagCommanderElement)
        }
          
        if (tcProductclick) {
            tcEventProductClick(tcProductclick, tagCommanderElement)
        }

        if (tcClickdownload) {
            tcEventDocumentationDownload(tcClickdownload, tagCommanderElement)
        }

        if (tcClickfaq) {
            tcEventFAQ(tcClickfaq, tagCommanderElement)
        }

        if(tcClickproducttab) {
            tcEventClickProductTab(tcClickproducttab, tagCommanderElement)
        }

        if (tcClicknavigation) {
            tcEventClickNavigation(tcClicknavigation, tagCommanderElement)
        }

        if (tcClicksort) {
            tcEventClickSort(tagCommanderElement)
        }

        if(tcClickbuyonlineretailerlogo) {
            tcEventClickBuyOnlineRetailerLogo(tcClickbuyonlineretailerlogo, tagCommanderElement)
        }

        if(tcClickbuyonlinebutton) {
            tcEventClickOnlineButton(tcClickbuyonlinebutton, tagCommanderElement)
        }

        if (tcClickseerecipe) {
            tcEventClickSeeRecipe(tcClickseerecipe, tagCommanderElement)
        }
    })
}

if (document.querySelectorAll('a[href]').length > 0) {    
    const windowURLOrigin = window.location.origin

    Array.from(document.querySelectorAll('a[href]')).forEach((link) => {
        const { tcIgnore } = link.dataset
        
        if (tcIgnore) return
        if (link.href.startsWith('/')) return
        if (link.href.startsWith(windowURLOrigin)) return
        
        tcEventClickExitLink(link)
    })
}

        